import { orgsFields } from '../../orgs.model';
import { ENROLLMENT_METHOD } from '../../../utils/constants';

export const validatePayerId = (value = "", allValues) => {
    const enrollmentMethod = allValues[orgsFields.enrollmentMethod];

    // If enrollment method is eligibility, payer ID is required
    if (enrollmentMethod === ENROLLMENT_METHOD.ELIGIBILITY) {
        if (!value || value?.trim() === '') {
        return 'Payer ID is required when enrollment method is Eligibility';
        }
    }

    return undefined; // No error
};
  
export const validateHealthieInsuranceId = (value = "", allValues) => {
    const enrollmentMethod = allValues[orgsFields.enrollmentMethod];

    // If enrollment method is eligibility, payer ID is required
    if (enrollmentMethod === ENROLLMENT_METHOD.ELIGIBILITY) {
        if (!value || (typeof value === 'string' && value.trim() === '') || (typeof value === 'number' && value === 0)) {
        return 'Healthie Insurance ID is required when enrollment method is Eligibility';
        }
    }

    return undefined; // No error
};